/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react'

export interface TrackingFiltersContextValue {
    containerDdoFilter: string[]
    locationFilter: string
    activeStatus: string | null
    setContainerDdoFilter: (value: string[]) => void
    setLocationFilter: (value: string) => void
    setActiveStatus: (value: string | null) => void
    clearAll: () => void
}

const TrackingFiltersContext = createContext<TrackingFiltersContextValue | undefined>(undefined)

interface TrackingFiltersProviderProps {
    children: ReactNode
}

export const TrackingFiltersProvider = ({ children }: TrackingFiltersProviderProps) => {
    const [containerDdoFilter, setContainerDdoFilter] = useState<string[]>([])
    const [locationFilter, setLocationFilter] = useState('')
    const [activeStatus, setActiveStatus] = useState<string | null>(null)

    const clearAll = useCallback(() => {
        setContainerDdoFilter([])
        setLocationFilter('')
        setActiveStatus(null)
    }, [])

    const value = useMemo<TrackingFiltersContextValue>(
        () => ({
            containerDdoFilter,
            locationFilter,
            activeStatus,
            setContainerDdoFilter,
            setLocationFilter,
            setActiveStatus,
            clearAll,
        }),
        [containerDdoFilter, locationFilter, activeStatus, clearAll],
    )

    return <TrackingFiltersContext.Provider value={value}>{children}</TrackingFiltersContext.Provider>
}

export const useTrackingFilters = () => {
    const context = useContext(TrackingFiltersContext)
    if (!context) {
        throw new Error('useTrackingFilters must be used within a TrackingFiltersProvider')
    }
    return context
}
